(function () {
    'use strict'

    angular
        .module('app.blog')
        .factory('blogFactory', function () {
            const vm = {}

            vm.category = null

            vm.setCategory = function (category) {
                vm.category = category
            }

            return vm
        })

})();
